import _ from "lodash";
import { NotificationManager } from "react-notifications";
import { Types } from "../actions/timesheetActions";

const defaultState = {
	timesheets: {},
};

const timesheetReducers = (state = defaultState, action) => {
	switch (action.type) {
		case Types.TIMESHEETS_OPEN_MODAL: {
			let newState = _.cloneDeep(state);

			console.log("action", action);
			newState.timesheets.modalState = action.status;
			newState.timesheets.modalTimesheet = action.timesheet;
			newState.timesheets.location = action.location;

			return newState;
		}
		case Types.TIMESHEETS_SAVING: {
			let newState = _.cloneDeep(state);

			newState.timesheets.modalSaving = action.saving;

			return newState;
		}
		case Types.TIMESHEETS_PROCESSING: {
			let newState = _.cloneDeep(state);
			newState.timesheets.processing = action.status;
			if (action.status) {
				newState.timesheets.employees = null;
				newState.timesheets.timesheets = null;
			}

			return newState;
		}
		case Types.TIMESHEETS_GET: {
			let newState = _.cloneDeep(state);

			const response = action.payload;

			const timesheetData = [];

			response &&
				response.summary &&
				Object.keys(response.summary).map((employeeId) => {
					const employee = response.employees.find((item) => item.id == employeeId);
					timesheetData.push({
						...response.summary[employeeId],
						employeeId,
						agreement: employee?.id,
						employee,
						timesheets: response.timesheets && response.timesheets[employeeId],
					});
				});

			console.log("TSData", timesheetData);

			// setProcessing(false);
			// setEmployees(response.employees)

			// const sortedResults = _.sortBy(timesheetData,(item) => `${item.employee.name} ${item.employee.surname}`)
			const sortedResults = _.sortBy(
				timesheetData,
				(item) => `${item.employee && item.employee.surname} ${item.employee && item.employee.name}`,
			);
			// TODO support different sorting options...

			newState.timesheets.processing = false;
			newState.timesheets.employees = response.employees;
			newState.timesheets.timesheets = sortedResults;

			return newState;
		}
		case Types.TIMESHEETS_APPROVED: {
			let newState = _.cloneDeep(state);

			action.timesheets.map((timesheet) => {
				const employeeIndex =
					newState.timesheets &&
					newState.timesheets.timesheets &&
					newState.timesheets.timesheets.findIndex((item) => item.employeeId == timesheet.agreement);

				if (employeeIndex > -1) {
					const timesheetIndex = newState.timesheets.timesheets[employeeIndex].timesheets.findIndex(
						(item) => item.id == timesheet.id,
					);

					if (timesheetIndex > -1) {
						const prevStatus =
							newState.timesheets.timesheets[employeeIndex].timesheets[timesheetIndex].status;

						const prevHours =
							prevStatus == "deleted"
								? 0
								: newState.timesheets.timesheets[employeeIndex].timesheets[timesheetIndex].hours;

						const newHours = timesheet.status == "deleted" ? 0 : timesheet.hours;
						const diff = newHours - prevHours;

						newState.timesheets.timesheets[employeeIndex].timesheets[timesheetIndex] = timesheet;

						// update the total timesheets
						newState.timesheets.timesheets[employeeIndex].total += diff;
						newState.timesheets.timesheets[employeeIndex].unpaid += diff;
					}
				}
			});

			return newState;
		}
		case Types.TIMESHEETS_SAVE_CURRENT_TIMESHEET: {
			let newState = _.cloneDeep(state);

			const employeeIndex =
				newState.timesheets &&
				newState.timesheets.timesheets &&
				newState.timesheets.timesheets.findIndex((item) => item.agreement == action.timesheet.agreement);

			if (employeeIndex > -1) {
				const timesheetIndex = newState.timesheets.timesheets[employeeIndex].timesheets.findIndex(
					(item) => item.id == action.timesheet.id,
				);

				if (timesheetIndex > -1) {
					const prevStatus = newState.timesheets.timesheets[employeeIndex].timesheets[timesheetIndex].status;

					const prevHours =
						prevStatus == "deleted"
							? 0
							: newState.timesheets.timesheets[employeeIndex].timesheets[timesheetIndex].hours;

					const newHours = action.timesheet.status == "deleted" ? 0 : action.timesheet.hours;
					const diff = newHours - prevHours;

					newState.timesheets.timesheets[employeeIndex].timesheets[timesheetIndex] = action.timesheet;

					// update the total timesheets
					newState.timesheets.timesheets[employeeIndex].total += diff;
					newState.timesheets.timesheets[employeeIndex].unpaid += diff;
				}
			}

			console.log("TIMESHEET_SAVED", action);
			newState.timesheets.modalSaving = false;
			newState.timesheets.timesheetSaved = true;
			newState.timesheets.modalState = false;
			newState.timesheets.modalTimesheet = null;

			if (action.timesheet.status == "deleted") {
				NotificationManager.success(`Your Timesheet has been deleted`, "Success");
			} else {
				NotificationManager.success(`Your Timesheet has been saved`, "Success");
			}

			return newState;
		}
		case Types.TIMESHEETS_IMAGE_PREVIEW: {
			let newState = _.cloneDeep(state);
			newState.timesheets.loadingImage = action.processing;
			if (action.image) {
				newState.timesheets.images.push(action.image);
			}
			return newState;
		}
		case Types.TIMESHEETS_IMAGE_PREVIEW_MODAL: {
			let newState = _.cloneDeep(state);
			newState.timesheets.imagePreview = {
				isModalOpen: action.status,
				openFile: action.image,
			};
			return newState;
		}
		case Types.TIMESHEETS_SHOW_COMMENTS: {
			let newState = _.cloneDeep(state);

			newState.timesheets.showComments = action.timesheet;

			return newState;
		}
		default:
			return state;
	}
};

export default timesheetReducers;
